import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import axios from "axios";
import HomePage from "./pages/HomePage";
import EmployersPage from "./pages/EmployersPage";
import JobSeekersPage from "./pages/JobSeekersPage";
import AboutPage from "./pages/AboutPage";
import FAQPage from "./pages/FAQPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import TermsOfServicePage from "./pages/TermsOfServicePage";
import ConstructionPage from "./pages/ConstructionPage";
import WarehousePage from "./pages/WarehousePage";
import AgriculturePage from "./pages/AgriculturePage";
import TransportationPage from "./pages/TransportationPage";
import ColdStoragePage from "./pages/ColdStoragePage";
import FoodProcessingPage from "./pages/FoodProcessingPage";
import LocationPage from "./pages/LocationPage";
import BlogPage from "./pages/BlogPage";
import BlogPostPage from "./pages/BlogPostPage";
import AdminBlogPage from "./pages/AdminBlogPage";
import ChatWidget from "./components/ChatWidget";
import { Toaster } from "./components/ui/toaster";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function App() {
  useEffect(() => {
    const checkApi = async () => {
      try {
        const response = await axios.get(`${API}/`);
        console.log(response.data.message);
      } catch (e) {
        console.error(e, `errored out requesting / api`);
      }
    };
    checkApi();
  }, []);

  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/employers" element={<EmployersPage />} />
            <Route path="/job-seekers" element={<JobSeekersPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
            <Route path="/terms-of-service" element={<TermsOfServicePage />} />
            <Route path="/industries/construction" element={<ConstructionPage />} />
            <Route path="/industries/warehouse" element={<WarehousePage />} />
            <Route path="/industries/agriculture" element={<AgriculturePage />} />
            <Route path="/industries/transportation" element={<TransportationPage />} />
            <Route path="/industries/cold-storage" element={<ColdStoragePage />} />
            <Route path="/industries/food-processing" element={<FoodProcessingPage />} />
            <Route path="/locations/vancouver" element={<LocationPage locationKey="vancouver" />} />
            <Route path="/locations/surrey" element={<LocationPage locationKey="surrey" />} />
            <Route path="/locations/burnaby" element={<LocationPage locationKey="burnaby" />} />
            <Route path="/locations/richmond" element={<LocationPage locationKey="richmond" />} />
            <Route path="/locations/delta" element={<LocationPage locationKey="delta" />} />
            <Route path="/locations/langley" element={<LocationPage locationKey="langley" />} />
            <Route path="/locations/abbotsford" element={<LocationPage locationKey="abbotsford" />} />
            <Route path="/locations/coquitlam" element={<LocationPage locationKey="coquitlam" />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:slug" element={<BlogPostPage />} />
            <Route path="/admin/blog" element={<AdminBlogPage />} />
          </Routes>
        </BrowserRouter>
        <ChatWidget />
        <Toaster />
      </div>
    </HelmetProvider>
  );
}

export default App;
